import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-122">
      <FadeIn data-id="element-123">
        <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[28px]" data-id="element-124">
          El próximo parcial puede ser diferente. 🧠
        </h2>

        <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-125">
          {/* Option 1 */}
          <a href="https://tumanualdigital.com/cart/44079714402340:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gray-900 border border-gray-700 rounded-2xl hover:border-gray-500 transition-colors group pt-[0px] pb-[0px]" data-id="element-126">
            <div className="text-left mb-4 sm:mb-0" data-id="element-127">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-128">
                <span data-id="element-129">📘</span> MEGAPACK PSICOLOGÍA LISTA
              </h3>
              <div className="flex items-center gap-3 mt-1" data-id="element-130">
                <span className="text-red-400 line-through text-sm" data-id="element-131">
                  $35.400
                </span>
                <span className="text-2xl font-black text-white" data-id="element-132">
                  $19.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-gray-800 text-white font-bold py-3 px-6 rounded-xl group-hover:bg-gray-700 transition-colors w-full sm:w-auto text-center" data-id="element-133">
              → QUIERO MI MEGAPACK
            </div>
          </a>

          {/* Option 2 */}
          <a href="https://tumanualdigital.com/cart/44079723675684:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-sky-900/40 to-gray-900 border-2 border-sky-500 rounded-2xl hover:shadow-[0_0_30px_rgba(14,165,233,0.2)] transition-all group relative overflow-hidden" data-id="element-134">
            <div className="absolute top-0 right-0 bg-sky-500 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-135">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-136">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-137">
                <span data-id="element-138">🏆</span> MEGAPACK + CRITERIO PROFESIONAL
              </h3>
              <div className="flex items-center gap-3 mt-1" data-id="element-139">
                <span className="text-red-400 line-through text-sm" data-id="element-140">
                  $47.300
                </span>
                <span className="text-2xl font-black text-sky-400" data-id="element-141">
                  $27.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-sky-500 text-black font-bold py-3 px-6 rounded-xl group-hover:bg-sky-400 transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-142">
              → QUIERO EL COMBO COMPLETO
            </div>
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-400 font-medium" data-id="element-143">
          <span className="flex items-center gap-1.5" data-id="element-144">
            <Lock size={16} className="text-sky-500" data-id="element-145" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-146">
            <Zap size={16} className="text-yellow-400" data-id="element-147" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-148">
            <Shield size={16} className="text-sky-500" data-id="element-149" /> Garantía 7 días
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-gray-500" data-id="element-150">
          <span className="flex items-center gap-1.5" data-id="element-151">
            <CreditCard size={16} data-id="element-152" /> Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </FadeIn>
    </section>;
}